import type { AppRouteObject } from "../routes";
import { PendingListingRoute } from "./routes/PendingListingRoute";

const routes: AppRouteObject[] = [PendingListingRoute];

export default routes;
